import React from "react";
import { Helmet } from "react-helmet";
import { BRAND, SITE_URL, DEFAULT_IMAGE } from "./meta";

/**
 * Escreve título, descrição, canonical e as tags de compartilhamento da página.
 *
 * react-helmet já era dependência do projeto (package.json), só nunca tinha sido
 * usado — então isto não adiciona nenhuma biblioteca nova.
 *
 * Nota: todas as tags são sempre renderizadas, com o valor variando. Filho
 * condicional ({x && <meta/>}) dá problema no react-helmet, então o padrão aqui
 * é escolher o `content`, nunca esconder a tag.
 */
const Seo = ({ title, description, path = "", image = DEFAULT_IMAGE, noindex = false }) => {
  // A home fica com a barra final, para bater exatamente com o que o
  // public/sitemap.xml declara — canonical e sitemap divergentes se anulam.
  const canonical = path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;

  return (
    <Helmet>
      <html lang="pt-BR" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      {/* O canonical resolve os três hostnames que servem o mesmo conteúdo
          (www, www2, prod) apontando todos para um só. */}
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
